import Assessment from './assessment/Assessment.component';
import ButtonBack from '../../../component/buttton/ButtonBack.component';
import { useParams, useLocation } from "react-router";
import ParamTypes from '../../../core/interfaces/ParamTypes';


export default function Details() {
  var { id } = useParams<ParamTypes>();
  const location = useLocation();

  return (
    <>
      <ButtonBack to={location.pathname.includes('responder') ? `/loja/${id}/avaliacao` : '/loja'} />
      <Assessment />
    </>
  )
}
